import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BonCfDTO} from '../../../core/dtos/boncfs-dto';
import {CommandesService} from '../../../core/services/gestion-commandes/commandes.service';
import {UtilsService} from '../../../core/utils/utils.service';
import {SearchSupplierWrapper} from '../../../core/suppliers/wrappers/search-supplier-wrapper';
import {SearchSupplier} from '../../../core/suppliers/search-supplier';
import {BCF_STATUT, DATEPICKER_FR, HAS_GEF, HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {ValueDTO} from '../../../core/dtos/value-dto';
import {Auth2Service} from '../../../core/services/security/auth2.service';
import {GenericDatagridService} from '../../../core/services/generics/generic-datagrid.service';
import {cloneDeep as _cloneDeep} from 'lodash';
import {BonCfDetailDTO} from '../../../core/dtos/boncf-detail-dto';
import {WorkflowsService} from '../../../core/services/entities/workflows.service';
import {saveAs as fs_saveAs} from 'file-saver';
import {DomSanitizer} from '@angular/platform-browser';
import {DxDataGridComponent} from "devextreme-angular";

import CustomStore from "devextreme/data/custom_store";
import {Sort} from "../../../core/suppliers/generics/generic-request-supplier";
import {DevextremeService, FilterItem} from "../../../core/services/technique/devextreme.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {BoncfDetailService} from "../../../core/services/entities/boncf-detail.service";
import {GefAuditDto} from "../../../core/dtos/gef/gef-audit-dto";
import {GestionGefService} from "../../../core/services/gef/gestion-gef.service";
import {BoncfService} from "../../../core/services/entities/boncf.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-bc-refusees',
    templateUrl: './bc-refusees.component.html',
    styleUrls: ['./bc-refusees.component.scss'],
    standalone: false
})
export class BcRefuseesComponent implements OnInit , OnDestroy {


  commandesRefusees: BonCfDTO[];
  selectedBonCfs: BonCfDTO[];
  totalRecords = 0;
  loadingTable: boolean = false;

  // dialog edit
  bonCf: BonCfDTO;
  lignesBonCf: BonCfDetailDTO[];
  displayEditDialog: boolean = false;
  dialogTitle = 'Détails';

  // items pour le filtre de sélection des listes de besoin
  filterItemsListeBesoin: ValueDTO[];
  // items pour le filtre de sélection des unités de production
  filterItemsUdp: ValueDTO[];
  // items pour le filtre de sélection des fournisseurs
  filterItemsFournisseur: ValueDTO[];

  filterDatesLivraisons:Date[];

  fr:any;

  @ViewChild("grid") grid: DxDataGridComponent;

  dataSource: CustomStore;
  allMode: string;
  checkBoxesMode: string;

  listesBesoinsIdsSelected: number[] = [];
  udpIdsSelected: number[] = [];
  fournisseursIdsSelected: number[] = [];
  articleFilter: string;

  isActionDisabled: boolean = true;

  pathFile: string = HELP_FOLDERS.COMMANDES_FOURNISSEURS + '/bons-refusees';

  selectAll: boolean = false;
  numeroCommandeSelected: string;

  gefAuditListBonCommande: GefAuditDto[] = [];

  constructor(public auth2Svc: Auth2Service,
              public commandesSvc: CommandesService,
              private gds: GenericDatagridService,
              public wkfSvc:WorkflowsService,
              public utils: UtilsService,
              public domSanitizer: DomSanitizer,
              private dxSvc: DevextremeService,
              private toastSvc: ToastService,
              private bonCfDetailSvc: BoncfDetailService,
              private bonCfSvc: BoncfService,
              public gefSvc: GestionGefService) {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'always';
  }

  ngOnInit() {
    this.loadingTable = true;
    this.fr = DATEPICKER_FR;
    this.initFilters();
    this.initCustomStore();
  }

  ngOnDestroy(): void {
  }

  initFilters = (): void => {
    this.commandesSvc.getFilterItemsListeBesoin(BCF_STATUT.COMMANDE_REFUSEE).subscribe(response => {
      this.filterItemsListeBesoin = response.resultList;
    });

    this.commandesSvc.getFilterItemsUdp(BCF_STATUT.COMMANDE_REFUSEE).subscribe(response => {
      this.filterItemsUdp = response.resultList;
    });

    this.commandesSvc.getFilterItemsFfs(BCF_STATUT.COMMANDE_REFUSEE).subscribe(response => {
      this.filterItemsFournisseur = response.resultList;
    });
  }

  checkDisabledButtons = (): void => {
    this.grid.instance.getSelectedRowKeys()
      .then(rowsSelected => {
        this.isActionDisabled = rowsSelected.length === 0;
      });
  }

  initCustomStore = (): void => {
    this.dataSource = new CustomStore({
      key: 'id',
      load: (loadOptions: any) => {
        const pageSize: number = loadOptions.take || this.grid.instance.pageSize();
        const page: number = this.grid.instance.pageIndex();
        const sorts: Sort[] = this.dxSvc.dxToGrsSorts(loadOptions.sort);
        const ssWrapper = new SearchSupplierWrapper();
        const filters: FilterItem[] = this.dxSvc.dxToGrsFilters(loadOptions.filter);

        ssWrapper.filtersMap['statutCode'] = new SearchSupplier(BCF_STATUT.COMMANDE_REFUSEE);
        if (this.numeroCommandeSelected)
          ssWrapper.filtersMap['numeroBcf'] = new SearchSupplier(this.numeroCommandeSelected);
        if (this.articleFilter)
          ssWrapper.filtersMap['article'] = new SearchSupplier(this.articleFilter);
        if (!this.utils.isCollectionNullOrEmpty(this.filterDatesLivraisons)) {
          const startDate = this.filterDatesLivraisons[0].getTime();
          let stopDate = _cloneDeep(startDate);
          if (this.filterDatesLivraisons[1]) {
            stopDate = this.filterDatesLivraisons[1].getTime();
          }
          ssWrapper.filtersMap['startDateLivraison'] = new SearchSupplier(startDate);
          ssWrapper.filtersMap['stopDateLivraison'] = new SearchSupplier(stopDate);
        }

        if (this.listesBesoinsIdsSelected && this.listesBesoinsIdsSelected.length)
          ssWrapper.filtersMap['listesBesoins'] = new SearchSupplier(undefined, this.listesBesoinsIdsSelected);
        if (this.udpIdsSelected && this.udpIdsSelected.length)
          ssWrapper.filtersMap['udps'] = new SearchSupplier(undefined, this.udpIdsSelected);
        if (this.fournisseursIdsSelected && this.fournisseursIdsSelected.length)
          ssWrapper.filtersMap['ffs'] = new SearchSupplier(undefined, this.fournisseursIdsSelected);

        let urlPaginationParams = this.gds.getUrlPaginationParamsFromDataGridDx(pageSize, page, sorts);
        if (loadOptions && loadOptions.select && loadOptions.select[0] === 'id' && this.selectAll) {
          // Si je coche tout => Il faut omettre la pagination
          urlPaginationParams = this.gds.getUrlPaginationParamsFromDataGridDx(null, null, sorts);
        }

        return this.commandesSvc.searchCommandes(ssWrapper, urlPaginationParams).toPromise().then(response => {
          this.commandesRefusees = response.resultList;

          const resultSelectedRows = this.dxSvc.getRowsSelectedForDeferredMode(filters, response.resultList);
          if (resultSelectedRows) { return resultSelectedRows; }
          this.initGefAuditData();
          return {
            data: response.resultList,
            totalCount: response.totalElements
          }
        });
      },
      update: (key, values) => { return null; }
    });
  }

  initGefAuditData() {
    if (this.auth2Svc.hasFeature(this.auth2Svc.utilisateur, HAS_GEF)) {
      this.bonCfSvc.findGefAuditData(this.commandesRefusees.map(bcf => bcf.id)).subscribe(response => {
        this.gefAuditListBonCommande = response.allGefAuditList;
      });
    }
  }

  onChangeFilterDateLivraison = (): void => {
    if (this.grid)
      this.grid.instance.refresh();
  };

  onDateFilterValueChange = (dates):void => {
    this.filterDatesLivraisons = dates
    this.onChangeFilterDateLivraison();
  };

  onChangeFilterFournisseurs = ($event): void => {
    if (this.grid) {
      this.fournisseursIdsSelected = $event.value;
      this.grid.instance.refresh();
    }
  };

  onChangeFilterUdps = ($event): void => {
    if (this.grid) {
      this.udpIdsSelected = $event.value;
      this.grid.instance.refresh();
    }
  };

  onChangeFilterListesBesoins = ($event): void => {
    if (this.grid) {
      this.listesBesoinsIdsSelected = $event.value;
      this.grid.instance.refresh();
    }
  };

  onChangeFilterNumCommande = async($event: any): Promise<void> => {
    if (this.grid) {
      this.numeroCommandeSelected = $event.value;
      await this.grid.instance.refresh();
    }
  };

  onChangeFilterArticles = async ($event): Promise<void> => {
    if (this.grid) {
      this.articleFilter = $event.value;
      await this.grid.instance.refresh();
    }
  }

  deleteBonCfs = async(): Promise<void> => {
    let rowsSelected: any[] = await this.grid.instance.getSelectedRowKeys();

    const selectedBonCfs: BonCfDTO[] = rowsSelected.map(id => this.commandesRefusees.find(p => id === p.id));
    // on ne doit pas supprimer les bons de commandes des sites secondaires
    const bonCfsToDelete= selectedBonCfs.filter(boncf=>this.auth2Svc.isSiteLocal( boncf.site.id));
    const bonCfsToNoNotDelete= selectedBonCfs.filter(boncf=>!this.auth2Svc.isSiteLocal( boncf.site.id));

    if(!this.utils.isCollectionNullOrEmpty(bonCfsToNoNotDelete)){
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Vous ne pouvez pas supprimer la/les commande(s) ${bonCfsToNoNotDelete
        .map(item => item.numeroBcf)
        .join(', ')}. La/Les commande(s) appartiennent à un site référent.`);
    }

    if(!this.utils.isCollectionNullOrEmpty(bonCfsToDelete)){
      this.dxSvc.dxDeleteItemsConfirmation(rowsSelected, () => {
        this.commandesSvc.delete(bonCfsToDelete).subscribe(response => {
          if (!this.utils.isResponseSupplierError(response)) {
            this.grid.instance.refresh();
          }
        });
      });
    }
  };

  printPDFCommandes = (): void => {
    this.grid.instance.getSelectedRowKeys()
      .then(rowsSelected => {
        const selectedBonCfs: BonCfDTO[] = rowsSelected.map(id => this.commandesRefusees.find(p => id === p.id));
        this.commandesSvc.printPDFCommandes(selectedBonCfs).subscribe(response => {
          let blob = new Blob([response], {type: 'application/pdf'});
          fs_saveAs(blob, 'commandes-refusees.pdf');
        });
      });
  };

  help = (): void => undefined;

  cellClick = (e: any) => this.selectAll = (e.rowType === 'header');

  isConditionneParInError(data) {
    return data.details.some(detail => detail.conditionnePar && detail.conditionnePar > 0 && this.utils.modulo(detail.quantiteACommanderAjustee, detail.conditionnePar) != 0)
  }

  isMinimumCommandInError(data) {
    return data.details.some(detail => detail.quantiteACommanderAjustee < detail.minimumDeCommande);
  }

  isFraisPortApplyed(data) {
    return this.bonCfDetailSvc.computeFrancoDePort(data, data.details);
  }

  isHorsDelai(data) {
    return data.details.some(detail => detail.horsDelai);
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
